module.exports = __webpack_public_path__ + "static/media/03-banner-04-polanco@2x.1433bf7f.jpg";